import type { FaireProductEntity } from "../../entity_types/product";

export const p_b8xpmvhj5f: FaireProductEntity = {
  token: "p_b8xpmvhj5f",
  type: "product",
  name: "High Protein Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/efaf82db99a75974c7e83bee99399dc05b648f3630bb99c8f2c8d976fc538bc2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f073a82731190b06b78c8b202416ff3ae6b5f8ea0dad493435621b82d1febea.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:34.762Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
